import { css } from 'linaria';

export const downloadCatalogCart = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-row-start: 3;
  height: 104px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  &:hover {
    background-color: var(--control-minor);
  }

  @media (--to-tablet) {
    height: 80px;
  }

  @media (--only-mobile) {
    grid-row-start: 2;
  }
`;

export const downloadCatalogCartBody = css`
  display: flex;
  align-items: center;
  padding: 24px;

  @media (--only-tablet) {
    padding: 20px 24px;
  }

  @media (--only-mobile) {
    padding: 20px 16px;
  }
`;

export const downloadCatalogCartIcon = css`
  width: 20px;
  height: 20px;
`;

export const downloadCatalogCartImage = css`
  width: 120px;
  height: 100%;
  margin-right: 16px;
  object-fit: contain;

  @media (--to-tablet) {
    width: 92px;
    height: 80px;
  }
`;

export const downloadCatalogCartText = css`
  padding-left: 12px;
  && {
    && {
      line-height: 28px;
      color: var(--text-primary);

      @media (--to-tablet) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;
